import { render, staticRenderFns } from "./NearbyPage.vue?vue&type=template&id=1329fd48&scoped=true"
import script from "./NearbyPage.vue?vue&type=script&lang=js"
export * from "./NearbyPage.vue?vue&type=script&lang=js"
import style0 from "./NearbyPage.vue?vue&type=style&index=0&id=1329fd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329fd48",
  null
  
)

export default component.exports